<template>
  <div class="col-12 spinner-box" style="text-align: center;">
    <ProgressSpinner v-if="loading" style="width:25vw;height:30vh; margin-top:20em"
                     :style="($vssWidth > 900 ? 'margin-left:17vw' : '')"
                     animationDuration=".5s"/>
  </div>
  <div :class="(loading ? 'layout-esmo blur-background' : 'layout-esmo')">
    <Toast/>
    <div :class="containerClass" @click="onWrapperClick">
      <AppTopBar @menu-toggle="onMenuToggle"/>
      <div class="layout-menu-left" :style="dynamicMenuHeight()">
        <Button class="layout-menu-left-item sub-item" @click="toPressMediaHub"
                :label="$t('menu.pressMediaHUB')"/>
        <Button class="layout-menu-left-item sub-item" @click="toEventsCalendar"
                :label="$t('menu.eventsCalendar')"/>
      </div>
      <div class="layout-main-container">
        <div class="layout-main">
          <div class="layout-body-top">
            <div class="layout-body-breadcrumb">
              {{ meetingName }}
              <div class="layout-body-title">
                {{ $t('breadcrumb.' + this.$route.name) }}
              </div>
            </div>
          </div>
          <div class="layout-main-content">
            <router-view/>
          </div>
        </div>
        <AppFooter/>
      </div>

      <transition name="layout-mask">
        <div class="layout-mask p-component-overlay" v-if="mobileMenuActive"></div>
      </transition>
    </div>
  </div>
</template>

<script>
import AppTopBar from './AppTopbar.vue';
import AppFooter from './AppFooter.vue';
import EventBus from "@/AppEventBus";
import {useUserStore} from "@/store/userStore";
import {useApplicationStore} from "@/store/applicationStore";
import {useAccreditationStore} from "@/store/accreditationStore";
import {VueScreenSizeMixin} from "vue-screen-size";
import {useLoadingStore} from "@/store/loadingStore";

export default {
  mixins: [VueScreenSizeMixin],
  components: {
    'AppTopBar': AppTopBar,
    'AppFooter': AppFooter,
  },
  emits: ['change-theme'],
  beforeCreate() {
    this.userStore = useUserStore()
    this.applicationStore = useApplicationStore()
    this.accreditationStore = useAccreditationStore()
    this.loadingStore = useLoadingStore()
  },
  beforeUpdate() {
    if (this.mobileMenuActive)
      this.addClass(document.body, 'body-overflow-hidden');
    else
      this.removeClass(document.body, 'body-overflow-hidden');
  },
  created() {
    window.addEventListener('scroll', ()=>{
      this.scrollPositionY = window.scrollY.toFixed(0);
    })
  },
  data() {
    return {
      scrollPositionY: 0,
      layoutMode: 'overlay',
      staticMenuInactive: false,
      overlayMenuActive: false,
      mobileMenuActive: false,
      menu: []
    }
  },
  computed: {
    user() {
      return this.userStore.user
    },
    loading() {
      return this.loadingStore.loading
    },
    containerClass() {
      return ['layout-wrapper', {
        'layout-overlay': this.layoutMode === 'overlay',
        'layout-static': this.layoutMode === 'static',
        'layout-static-sidebar-inactive': this.staticMenuInactive && this.layoutMode === 'static',
        'layout-overlay-sidebar-active': this.overlayMenuActive && this.layoutMode === 'overlay',
        'layout-mobile-sidebar-active': this.mobileMenuActive,
        'p-input-filled': this.$primevue.config.inputStyle === 'filled',
        'p-ripple-disabled': this.$primevue.config.ripple === false
      }];
    },
    logo() {
      return (this.$appState.darkTheme) ? "images/logo-white.svg" : "images/logo.svg";
    },
    meetingName() {
      if(this.applicationStore.meeting != null && this.applicationStore.meeting.name != null){
        return this.applicationStore.meeting.name
      }
      return this.$t('breadcrumb.esmo')
    }
  },
  watch: {
    $route() {
      this.menuActive = false;
      this.$toast.removeAllGroups();
    }
  },
  methods: {
    dynamicMenuHeight(){
      const top = 133
      return  this.scrollPositionY <= 133 ? ('top:' + (top - this.scrollPositionY)) + 'px' : 'top: ' + 0
    },
    goBack() {
      location.href = this.applicationStore.callBackUrl
    },
    toHome() {
      EventBus.emit('navigation-home');
    },
    toPressMediaHub() {
      location.href = "https://www.esmo.org/newsroom/press-and-media-hub"
    },
    toEventsCalendar() {
      location.href = "https://www.esmo.org/newsroom/press-and-media-hub/meetings-calendar-for-press"
    },
    toAccreditation() {
      EventBus.emit('navigation-accreditation');
    },
    toAccreditations() {
      EventBus.emit('navigation-accreditations');
    },
    onWrapperClick() {
      if (!this.menuClick) {
        this.overlayMenuActive = false;
        this.mobileMenuActive = false;
      }

      this.menuClick = false;
    },
    onMenuToggle() {
      this.menuClick = true;

      if (this.isDesktop()) {
        if (this.layoutMode === 'overlay') {
          if (this.mobileMenuActive === true) {
            this.overlayMenuActive = true;
          }

          this.overlayMenuActive = !this.overlayMenuActive;
          this.mobileMenuActive = false;
        } else if (this.layoutMode === 'static') {
          this.staticMenuInactive = !this.staticMenuInactive;
        }
      } else {
        this.mobileMenuActive = !this.mobileMenuActive;
      }

      event.preventDefault();
    },
    onSidebarClick() {
      this.menuClick = true;
    },
    onMenuItemClick(event) {
      if (event.item && !event.item.items) {
        this.overlayMenuActive = false;
        this.mobileMenuActive = false;
      }
    },
    onLayoutChange(layoutMode) {
      this.layoutMode = layoutMode;
    },
    addClass(element, className) {
      if (element.classList)
        element.classList.add(className);
      else
        element.className += ' ' + className;
    },
    removeClass(element, className) {
      if (element.classList)
        element.classList.remove(className);
      else
        element.className = element.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
    },
    isDesktop() {
      return window.innerWidth >= 992;
    },
    isSidebarVisible() {
      if (this.isDesktop()) {
        if (this.layoutMode === 'static')
          return !this.staticMenuInactive;
        else if (this.layoutMode === 'overlay')
          return this.overlayMenuActive;
      }
      return true;
    },
    init() {
      // Runs only on a full page load (hard refresh / first visit), never on in-app step navigation, 
      // so this clears stale sessionStorage-persisted form input without affecting steps transitions
      this.applicationStore.setFormData({})
      this.accreditationStore.setPersonalFields({})
      this.accreditationStore.setWorkFields({})
      this.accreditationStore.setAttedanceFields({})
      this.accreditationStore.setTermsConditionsFields({})
      this.accreditationStore.setShowPersonal(true)
      this.accreditationStore.setShowWork(false)
      this.accreditationStore.setShowTermsAndConditions(false)
      this.accreditationStore.setShowSubmitted(false)

      this.applicationStore.initMeetings();
      this.applicationStore.setMeetingCode(this.$route.query.meeting)
      this.applicationStore.setCallBackUrl(this.$route.query.callBackUrl)
      this.accreditationStore.initSalutations();
      this.accreditationStore.initGenders();
      this.accreditationStore.initCountries();
      this.accreditationStore.initProfessions();
      this.accreditationStore.initPrimaryActivities();
      this.accreditationStore.initRoles();
      this.accreditationStore.initMediums();
      this.accreditationStore.initPublicationLanguages();
      this.accreditationStore.initPublicationTargets();
      this.accreditationStore.initPublicationTypes();
      this.accreditationStore.initEditorialInterests();
      this.accreditationStore.initFocusAreas();
      this.accreditationStore.initAttendanceTypes();
      this.accreditationStore.initFilmingActivities();
      this.accreditationStore.initHowToContactTypes();
    }
  },
  beforeMount() {
    this.init()
  }
}
</script>

<style lang="scss">
@import './App.scss';

.blur-background {
  filter: blur(4px);
  -webkit-filter: blur(4px);
  height: 100%;
}

.blur-background-dialog {
  filter: blur(4px);
  -webkit-filter: blur(4px);
}

.layout-body-top {
  background-image: url("/public/images/bg_header_default.png") !important;
}
.layout-main-content {
  max-width: 1174px;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
}
</style>
